export const components = {
  '* Promotional areas with special values exclusive to some units may only be schedule at those units':
    '* Áreas promocionais com valores especiais exclusivas de unidades só podem ser agendadas nas mesmas',
  Afternoon: 'Tarde',
  'Avoid sun exposition 15 days before the session for areas that are highly exposed to the sun and 5 days for less exposed areas':
    'Evitar exposição solar de 15 dias antes da sessão para áreas muito expostas ao sol e 5 dias antes para áreas menos expostas.',
  'Below some time suggestions for you':
    'Abaixo algumas recomendações de horários para você',
  'Choose another time': 'Escolher outro horário',
  City: 'Cidade',
  Clinic: 'Clínica',
  'Do you want to speed up this process?': 'Quer acelerar este processo?',
  'Follow the recommendations below': 'Siga as recomendações abaixo',
  'It was not possible to reschedule': 'Não foi possível reagendar',
  'Last clinic': 'Última clínica',
  Morning: 'Manhã',
  Night: 'Noite',
  Recommendations: 'Recomendações',
  'Remember to arrive on time to avoid lines and embarrassement':
    'Lembre-se de chegar no horário para evitar filas e constrangimento.',
  'Schedule at last clinic': 'Agendar na última clínica',
  'Schedule on this time': 'Agendar neste horário',
  Select: 'Selecione',
  'Select a day to see the available times':
    'Selecione um dia para ver os horários disponíveis',
  State: 'Estado',
  "Trim the hairs with a blade or cream 2 days before the session It's important that only the tip of the hair is exposed":
    'Aparar os pelos com lâmina ou creme depilatório 2 dias antes da sessão. É importante que apenas a ponta do pelo esteja exposta.',
  Unavailable: 'Indisponível',
  Understood: 'Entendi',
};
